import {Box, Container} from "@mui/system";
import React, {useEffect, useState} from "react";
import {constantsErrorMessages} from "../../Constants";
import ModalAlert from "../../components/UI/table/customer-detales/ModalAlert";
import {BreadcrumbsComponent} from "../../components/UI/breadcrumb/BreadcrumbComponent";
import {Button, Paper, Typography} from "@mui/material";
import Footer from "./Footer";
import Card from "../../components/UI/Card";
import {Link, useLocation, useNavigate} from "react-router-dom";
import UtilityNewsService from "../../API/admin/UtilityNewsService";
import UtilityPromotionService from "../../API/admin/UtilityPromotionService";
import TextFieldValidation from "../../components/UI/table/customer-detales/TextFieldValidation";
import MenuItem from "@mui/material/MenuItem";
import {ReactComponent as ArrowCarousel} from "../../components/Icons/arrowCarousel.svg"

const NewsAndStock = ({news}) => {
    const location = useLocation()
    const navigate = useNavigate();
    const api = news ? UtilityNewsService : UtilityPromotionService

    const [alertData, setAlertData] = useState({});

    const [data, setData] = useState([])
    const [dataCarousel, setDataCarousel] = useState([])
    const [themes, setThemes] = useState([]);
    const [currentTheme, setCurrentTheme] = useState({theme: ""});
    const [page, setPage] = useState(0);
    const [lastPage, setLastPage] = useState(false);

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }

    useEffect(() => {
        api.getPage().then(function (response) {
            const relevant = response.data.relevant.sort((a, b) => a.priorityRelevant - b.priorityRelevant).splice(0, 5)
            const popular = response.data.popular.sort((a, b) => a.priorityPopular - b.priorityPopular).splice(0, 5)
            setData({relevant, popular})
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
        api.getThemeUser().then(function (response) {
            setThemes(response.data);
            setCurrentTheme({theme: response.data[0]?.id})
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [news])

    useEffect(() => {
        currentTheme?.theme && api.getFilter(currentTheme?.theme, page).then(function (response) {
            setDataCarousel(response.data.content);
            if ((response.data.total - 5 * page) < 5) {
                setLastPage(true)
            } else {
                setLastPage(false)
            }
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [news, currentTheme, page]);

    const onClickHandle = (el) => {
        navigate(`${location.pathname}/${el.id}`);
    }

    return <>
        <ModalAlert
            data={alertData}
            onClose={() => setAlertData((alert) => ({...alert, open: false}))}
        />

        <>
            <Paper sx={{
                width: '100%',
                display: 'flex',
                justifyContent: "space-between",
                padding: "0 0 40px 0",
            }}>
                <Container sx={{
                    "&.MuiContainer-root": {
                        maxWidth: "1668px",
                        display: 'flex',
                        flexDirection: "column",
                        gridGap: "100px",
                    },
                }}>
                    <Box>
                        <BreadcrumbsComponent
                            page={news ? "Новости" : "Акции"}
                            path={[
                                {name: "Главная", href: "/"},
                            ]}/>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: "column",
                            gridGap: "40px",
                            justifyContent: "center",
                            width: "100%",
                        }}>
                            <Typography sx={{
                                fontSize: "40px", fontWeight: 700, lineHeight: 1,
                                '@media (max-width: 1450px)': {
                                    fontSize: "28px",
                                }
                            }}>
                                {news ? "Актуальные новости" : "Актуальные акции"}
                            </Typography>
                            <Box sx={{
                                display: "grid",
                                gap: "16px",
                                gridTemplateAreas: `"news1 news1 news2 news3" "news1 news1 news4 news5"`,
                            }}>
                                {data?.relevant?.map((el, i) => {
                                    return <Box key={el.id} sx={{
                                        gridArea: `news${i + 1}`
                                    }}
                                    >
                                        <Card
                                            key={el.id}
                                            element={el}
                                            clickable={true}
                                            picturePosition={"top"}
                                            width={i === 0 ? 802 : 392}
                                            height={i === 0 ? 680 : 332}
                                            imgHeight={i === 0 && "474px"}
                                            onClickHandle={() => onClickHandle(el)}
                                        />
                                    </Box>
                                })}
                            </Box>
                            <Typography sx={{
                                fontSize: "40px", fontWeight: 700, lineHeight: 1,
                                '@media (max-width: 1450px)': {
                                    fontSize: "28px",
                                }
                            }}>
                                {news ? "Популярные новости" : "Популярные акции"}
                            </Typography>
                            <Box sx={{
                                display: "grid",
                                gap: "16px",
                                gridTemplateAreas: `                               
                                    "news1 news3"
                                    "news1 news4"
                                    "news2 news4"
                                    "news2 news5"`,
                            }}>
                                {data?.popular?.map((el, i) => {
                                    return <Box key={el.id} sx={{
                                        gridArea: `news${i + 1}`
                                    }}
                                    >
                                        <Card
                                            element={el}
                                            clickable={true}
                                            picturePosition={"left"}
                                            width={802}
                                            height={i === 0 || i === 1 ? 332 : 216}
                                            imgWidth={i === 0 || i === 1 ? "365px" : "173px"}
                                            onClickHandle={() => onClickHandle(el)}
                                        />
                                    </Box>
                                })}
                            </Box>
                            <Box sx={{display: "flex", justifyContent: "space-between"}}>
                                <Typography sx={{
                                    fontSize: "40px", fontWeight: 700, lineHeight: 1,
                                    '@media (max-width: 1450px)': {
                                        fontSize: "28px",
                                    }
                                }}>
                                    Вам также может быть интересно
                                </Typography>
                                <Box sx={{width: "300px"}}>
                                    <TextFieldValidation
                                        select
                                        name="theme"
                                        label="Тема"
                                        margin={"none"}
                                        disabled={!currentTheme.theme}
                                        value={currentTheme?.theme}
                                        setCurrValues={setCurrentTheme}
                                    >
                                        {themes.map((option) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.title}
                                            </MenuItem>
                                        ))}
                                    </TextFieldValidation>
                                </Box>
                            </Box>
                            <Box sx={{
                                position: "relative",
                                display: "flex",
                                gap: "4px"
                            }}>
                                <Box sx={{
                                    display: "flex", gap: "16px",
                                }}>
                                    {dataCarousel.map((el) => {
                                        return <Card
                                            key={el.id}
                                            element={el}
                                            clickable={true}
                                            picturePosition={"top"}
                                            width={311}
                                            height={380}
                                            imgHeight={"174px"}
                                            onClickHandle={() => onClickHandle(el)}
                                        />
                                    })}
                                </Box>
                                {page !== 0 && <Button
                                    onClick={() => setPage(prev => prev - 1)}
                                    sx={{
                                        position: "absolute",
                                        transform: "rotate(180deg)",
                                        top: "160px",
                                        left: "0px",
                                        backgroundColor: 'transparent',
                                        opacity: `1!important`,
                                        margin: 0,
                                        padding: 0,
                                        "&:hover": {
                                            backgroundColor: 'transparent',
                                            opacity: `1!important`,
                                        }
                                    }}
                                >
                                    <ArrowCarousel/>
                                </Button>}
                                {!lastPage && <Button
                                    onClick={() => setPage(prev => prev + 1)}
                                    sx={{
                                        position: "absolute",
                                        top: "160px",
                                        right: "0px",
                                        backgroundColor: 'transparent',
                                        opacity: `1!important`,
                                        margin: 0,
                                        padding: 0,
                                        "&:hover": {
                                            backgroundColor: 'transparent',
                                            opacity: `1!important`,
                                        }
                                    }}>
                                    <ArrowCarousel style={{}}/>
                                </Button>}
                            </Box>
                        </Box>
                    </Box>
                </Container>
            </Paper>
            <Footer></Footer>
        </>
    </>
}
export default NewsAndStock